/**
 * @file
 * Sliders.
 */
(function ($, Drupal, drupalSettings, once) {

  'use strict';

  Drupal.behaviors.tabOverflow = {
    attach: function (context, settings) {
      let menuSelector = '.course-summary__nav .nav.nav-tabs';

      once('tabOverflow', menuSelector, context).forEach(function() {
        Drupal.autoCollapse(menuSelector);

        // When the window is resized.
        $(window).on('resize', Drupal.debounce(function () {
          Drupal.autoCollapse(menuSelector);
        }, 150));
      });
    }
  };

})(jQuery, Drupal, drupalSettings, once);
